import { FC } from "react";
import { useTranslation } from "react-i18next";
import { CourseActiveBadge, CourseCompletedBadge } from "./styles";

export const COMPLETED_LMS_COURSE_STATUS = 1;

/**
 * Шильдик состояния курса на витрине внешней организации
 */
export const CourseStatusBadge: FC<{ lmsCourseStatus?: number }> = ({ lmsCourseStatus }) => {
    const { t } = useTranslation();

    return lmsCourseStatus === COMPLETED_LMS_COURSE_STATUS
        ? <CourseCompletedBadge>{t('teams.adminPage.courseCard.statusCompleted')}</CourseCompletedBadge>
        : <CourseActiveBadge>{t('teams.adminPage.courseCard.statusActive')}</CourseActiveBadge>
}
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { CourseActiveBadge, CourseCompletedBadge } from "./styles";

export const COMPLETED_LMS_COURSE_STATUS = 1;

/**
 * Шильдик состояния курса на витрине внешней организации
 */
export const CourseStatusBadge: FC<{ lmsCourseStatus?: number }> = ({ lmsCourseStatus }) => {
    const { t } = useTranslation();

    return lmsCourseStatus === COMPLETED_LMS_COURSE_STATUS
        ? <CourseCompletedBadge>{t('teams.adminPage.courseCard.statusCompleted')}</CourseCompletedBadge>
        : <CourseActiveBadge>{t('teams.adminPage.courseCard.statusActive')}</CourseActiveBadge>
}
